module.exports = __webpack_public_path__ + "img/mudancas-fretes-residencial.d25bdf4c.webp";